<template>
	<div>
		<div class="page-body">
			<div style="display: flex; justify-content: space-between">
				<div>
					<el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px"
						:model="searcheForm">
						<el-form-item label="模板名称:">
							<el-input placeholder="请输入昵称" clearable width="200px" v-model="searcheForm.name"></el-input>
						</el-form-item>
						<el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
					</el-form>
				</div>
				<div>
					<el-button type="primary" icon="el-icon-plus" @click="showAdd">新增</el-button>
				</div>
			</div>
		</div>
		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="dataList" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column prop="name" label="模板名称" fixed align="center" width="300"></el-table-column>
				<el-table-column prop="code" label="计费编号" width="300" align="center"></el-table-column>
				<el-table-column prop="feeType" label="计费方式" width="200" align="center">
					<template slot-scope="scope">
						<el-tag type="primary" v-if="scope.row.feeType===1">按小时计费</el-tag>
						<el-tag type="success" v-if="scope.row.feeType===2">按电量计费</el-tag>
						<el-tag type="success" v-if="scope.row.feeType===3">谷峰分时计费</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="单价(分/小时)" width="200" align="center"></el-table-column>
				<el-table-column prop="elecPrice" label="电费(元/度)" width="200" align="center"></el-table-column>
				<el-table-column prop="servicePrice" label="服务费(元/度)" width="200" align="center"></el-table-column>
				<el-table-column prop="durationOption" label="计费时段" width="300" align="center"></el-table-column>
				<el-table-column prop="cusPayAmount" label="可选付费" width="300" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" width="500" align="center"></el-table-column>
				<el-table-column fixed="right" width="200" align="center" label="操作">
					<template slot-scope="scope">
						<el-button @click="showEdit(scope.row)">编辑</el-button>
						<el-button @click="deletePricePrivacy(scope.row)" type="danger"
							style="display:none">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex; justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1200px">
			<div style="width: 1200px">
				<el-form :model="form" :rules="formRules" ref="formRef" label-position="right" label-width="150px"
					size="600px">
					<el-form-item label="模板名称:" prop="name">
						<el-input size="mini" style="width: 85%" prefix-icon="el-icon-edit" v-model="form.name"
							placeholder="请输入计费模板名称"></el-input>
					</el-form-item>
					<el-form-item label="模板编码:" prop="code">
						<el-input size="mini" style="width: 85%" prefix-icon="el-icon-edit" v-model="form.code"
							placeholder="请输入计费模板编码"></el-input>
					</el-form-item>
					<el-form-item label="经度:" prop="form.stationLng" style="display: none">
						<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="form.stationLng"
							placeholder="请输入经度"></el-input>
					</el-form-item>
					<el-form-item label="纬度:" prop="form.stationLat" style="display: none">
						<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="form.stationLat"
							placeholder="请输入纬度"></el-input>
					</el-form-item>
					<el-row>
						<el-col :span="10">
							<el-form-item label="计费方式:" prop="feeType" width="100%">
								<el-select v-model="form.feeType" placeholder="请选择" width="100%"
									@change="feeTypeChange">
									<el-option v-for="item in feeTypeOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="10"><el-form-item label="免费充电时长:" prop="maxFreeMinutes">
								<el-input-number style="width: 85%" v-model="form.maxFreeMinutes"
									@change="handleChangeFreeFee" :min="1" :max="600" label="免费充电时长"></el-input-number>
								<span>&nbsp;&nbsp;分钟</span>
							</el-form-item></el-col>
					</el-row>



					<el-row v-if="form.feeType ===1">
						<el-col :span="22"><el-form-item label="充电时段设置:" prop="durationOption" v-if="form.feeType ===1">
								<el-input size="mini" style="width: 45%" prefix-icon="el-icon-edit"
									v-model="form.durationOption" placeholder="请输入充电时段，以逗号[,]分割"></el-input>
								<span> &nbsp; &nbsp; &nbsp; &nbsp;充电时段用于选择充电用户可选择充电时长，如[1,2,4,8]</span>
							</el-form-item></el-col>
					</el-row>
					<el-row v-if="form.feeType ===1">
						<el-col :span="10">
							<el-form-item label="价格:" prop="priceYuan">
								<el-input-number style="width: 75%" v-model="form.priceYuan" @change="handleChangePrice"
									:min="0" :max="10" :step="0.01" :precision="2" label="电费价格"></el-input-number>
								<!-- <el-input size="mini" oninput="value=value.replace(/[^\d]/g,'')" style="width: 85%"
									prefix-icon="el-icon-edit" v-model="form.priceYuan" placeholder="请输入计费价格 分/小时"></el-input> -->
								<span>&nbsp;&nbsp;元/小时</span>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="折算:" prop="price">
								{{ parseInt(form.priceYuan * 100 )}}
								<span>&nbsp;&nbsp;分/小时</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="折扣费率:" prop="discountRate" style="display: none">
						<el-input-number v-model="form.discountRate" @change="handleChange" :min="10" :max="1000"
							label="描述文字"></el-input-number>
					</el-form-item>

					<el-row v-if="form.feeType===2 ">
						<el-col :span="22"><el-form-item label="支付选项设置:" prop="cusPayAmountOption">
								<el-input size="mini" style="width: 45%" prefix-icon="el-icon-edit"
									v-model="form.cusPayAmount" placeholder="请输入充电时段，以逗号[,]分割"></el-input>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;支付选项用于小程序用户自由选择支付金额，如[1,2,4,8]</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-if="form.feeType===2">

						<el-col :span="10">
							<el-form-item label="电费价格:" prop="maxFreeMinutes" v-if="form.feeType ===2">
								<el-input-number style="width: 85%" v-model="form.elecPrice"
									@change="handleChangeElecPrice" :min="0" :max="10" :step="0.01" :precision="4"
									label="电费价格"></el-input-number>
								<span>&nbsp;&nbsp;元/度</span>
							</el-form-item>
						</el-col>
						<el-col :span="10">

							<el-form-item label="服务费单价:" prop="maxFreeMinutes" v-if="form.feeType ===2">
								<el-input-number style="width: 85%" v-model="form.servicePrice"
									@change="handleChangeServicePrice" :min="0" :max="10" :step="0.01" :precision="2"
									label="电费价格"></el-input-number>
								<span>&nbsp;&nbsp;元/度</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-if="form.feeType ===2">
						<el-col :span="24">

							<el-form-item label="合计单价:" prop="totalPrice">
								{{ form.elecPrice + form.servicePrice}}
								<span>&nbsp;&nbsp;元/度</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="备注:" prop="remark">
						<el-input type="textarea" style="width: 85%" v-model="form.remark"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="footer">
				<el-button type="primary" @click="doUpdate">保存设置</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		Message
	} from "element-ui";
	import {
		apiListPrivays,
		apiUpdate,
		apiGet,
		apiDelete
	} from "./FeePrivacy";

	export default {
		name: "FeePrivacy",
		data() {
			return {
				title: "", //模态窗口 标题
				searcheForm: {}, //搜索
				dataList: [], //列表数据
				loading: false,
				dialogVisible: false, // 是否显示 模态窗口
				total: 0,
				page: 1,
				size: 10,
				form: {
					feeType: 1,
					discountRate: 100,
					maxFreeMinutes: 1,
					elecPrice: 0,
					servicePrice: 0,
					priceYuan:0
				},
				feeTypeOptions: [{
						label: "按小时",
						value: 1
					},
					{
						label: "按电量",
						value: 2
					},
					{
						label: "谷锋分时计费",
						value: 3
					},
				],
				chargingPowerOptions: [{
						label: "0-200w",
						value: 200
					},
					{
						label: "200-400w",
						value: 400
					},
					{
						label: "400-600",
						value: 600
					},
				],
				durationOptions: [{
						label: "1小时",
						value: 1
					},
					{
						label: "2小时",
						value: 2
					},
					{
						label: "3小时",
						value: 3
					},
					{
						label: "4小时",
						value: 4
					},
					{
						label: "5小时",
						value: 5
					},
					{
						label: "6小时",
						value: 6
					},
					{
						label: "7小时",
						value: 7
					},
					{
						label: "8小时",
						value: 8
					},
				],
				formRules: {
					stationName: [{
							required: true,
							message: "请输入物业名称",
							trigger: "blur"
						},
						{
							min: 2,
							max: 15,
							message: "长度在 2 到 15 个字符",
							trigger: "blur",
						},
					],
					durationOption: [{
						required: true,
						message: "请输入充电时长配置",
						trigger: "blur"
					}, ],
					priceYuan: [{
							required: true,
							message: "请输入充电价格信息",
							trigger: "blur"
						},
						// {
						// 	min: 1,
						// 	max: 4,
						// 	message: "单位为元 如  1 元/小时",
						// 	trigger: "blur",
						// },
					],
					address: [{
							required: true,
							message: "请输入详细地址信息",
							trigger: "blur"
						},
						{
							min: 2,
							max: 100,
							message: "长度在 2 到 100 个字符",
							trigger: "blur",
						},
					],
					remark: [{
						required: false,
						message: "请填写备注",
						trigger: "blur"
					}]
				},
			};
		},
		created() {
			this.list();
		},
		mounted() {},
		methods: {
			list() {
				this.searcheForm.page = this.page;
				this.searcheForm.size = this.size;
				apiListPrivays(this.searcheForm).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.dataList = data.list;
						this.total = data.total;
						this.page = data.pageNum;
						this.size = data.pageSize;
					}
				});
			},
			search() {
				this.list();
			},
			showAdd() {
				this.title = "添加模板";
				this.form = {
					feeType: 1,
					elecPrice: 0,
					servicePrice: 0,
					priceYuan: 0,
					price: 0,
					maxFreeMinutes: 1,
				};
				this.dialogVisible = true;
			},
			feeTypeChange(row) {
				if (row === 1) {
					console.log('选择按小时计费')
					this.form.price=0
					this.priceYuan=0
					this.form.elecPrice = 0
					this.form.servicePrice = 0
					this.form.priceSeparate=0
				} else {
					console.log('选择按电量计费')
					this.form.price = 0
					this.form.priceYuan = 0
					this.form.durationOption = null
					this.form.priceSeparate=1
				}
			},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.list();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.list("advanced");
			},
			showEdit(data) {
				this.title = "编辑模板";
				this.form = data;
				this.form.priceYuan=this.form.price/100;
				this.dialogVisible = true;
				if(this.form.feeType===1){
					this.form.priceSeparate=0
				}else{
					this.form.priceSeparate=1
				}
			},
			deletePricePrivacy(row) {
				this.$confirm('当前计费[' + row.name + ']将被删除，是否执行此操作', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log('用户选择确认删除');
					this.deleteRow(row);
				}).catch(() => {

				});
			},
			deleteRow(row) {
				console.log('Prepare Delete Record');
				apiDelete(row.id).then((resp) => {
					if (resp.status == 200) {
						Message.success({
							message: "删除成功"
						});
						this.list();
					} else {
						Message.errot({
							message: "删除失败:" + resp.data.msg
						});
					}
				})
			},
			handleChange(v) {
				this.$refs.form.discountRate = v;
			},
			handleChangeFreeFee(v) {
				this.$refs.form.maxFreeMinutes = v;
			},
			handleChangeElecPrice(v) {
				console.log('按电量计费，电价=' + v)
			},
			handleChangeServicePrice(v) {
				console.log('按电量计费，服务费=' + v)
			},
			handleChangePrice(v) {
				console.log('按小时计费：' + v)
			},
			checkLong(lng) {
				var longrg =
					/^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
				if (!longrg.test(lng)) {
					Message.error({
						message: "经度整数部分为0-180,小数部分为0到6位!"
					});
					return false;
				}
				return true;
			},
			checkLat(lat) {
				var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
				if (!latreg.test(lat)) {
					Message.error({
						message: "纬度整数部分为0-90,小数部分为0到6位!"
					});
					return false;
				}
				return true;
			},
			handleChangeFreeFee(v) {
				this.$refs.form.maxFreeMinutes = v;
			},
			doUpdate() {
				let url = "/api/chargeStation/update";
				const valid = this.$refs["formRef"].validate((valid) => {
					if (!valid) {
						return;
					}
					if(this.form.feeType===1){
						this.form.price = parseInt(this.form.priceYuan * 100)
						console.log('计算this.form.price='+this.form.price)
						console.log('计算this.form.priceYuan='+this.form.priceYuan)
					}else{
						this.form.price = 0
						console.log('按电量计费：this.form.price='+this.form.price)
					}
					
					// checkDurationOption();
					apiUpdate(this.form).then((resp) => {
						let type = '更新';
						if (this.form.id == undefined || this.form.id == null || this.form.id == 0) {
							type = "添加";
						}
						if (resp.status == 200) {
							Message.success({
								message: type + "成功"
							});
						}
					});
				});
			},
			checkDurationOption() {
				let durationOption = this.form.durationOption;
				if (durationOption == null || durationOption.length == 0) {
					Message.error({
						message: "请设置有效的充电时段!"
					});
				}
				let index = durationOption.indexOf(",");
				let regex = /^\d+$/;
				if (index == -1) {
					if (!regex.test(durationOption)) {
						Message.error({
							message: "请设置有效的充电时段,只能输入数字，多时段通过[,]分割!",
						});
						return false;
					}
				}
				let texts = durationOption.split(",");
				for (let i = 0; i < texts.length; i++) {
					if (!regex.test(texts[i])) {
						Message.error({
							message: "请设置有效的充电时段," + texts[i] + "不是有效的参数",
						});
						return false;
					}
				}
				return true;
			},
			feeTypeFormatter(row, column, cellValue, index) {
				if (row.feeType == 1) {
					return "<el-tag type=\"primary\">按小时计费</el-tag>";
				}
				if (row.feeType == 2) {
					return "按电量计费";
				}
			}
		},
	};
</script>

<style>
	.page-body {
		margin-top: 30px;
	}

	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}

	.el-input--mini .el-input__inner {
		height: 48px;
		line-height: 48px;
	}

	.footer {
		padding-left: 500px;
	}
</style>